import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://localally.in';
const DEFAULT_OG = `${SITE_URL}/logo_1.jpeg`;

interface SEOProps {
  title: string;
  description: string;
  path?: string;
  image?: string;
  robots?: string;
  schema?: object | object[];
}

const SEO: React.FC<SEOProps> = ({
  title,
  description,
  path = '/',
  image = DEFAULT_OG,
  robots = 'index, follow',
  schema = null,
}) => {
  const canonical = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <html lang="en-IN" />
      <title>{title}</title>

      <meta name="description" content={description} />
      <meta name="robots" content={robots} />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="LocalAlly.in" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
